import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../../utils";
const SIZE_CLASSES = {
    sm: "size-5",
    md: "size-12",
    lg: "size-20"
};
const SPARKLE_TONES = [
    "bg-positive-solid",
    "bg-yellow-light-1",
    "bg-blue-primary"
];
const SPARKLE_COUNT = 10;
// Fixed per-index offsets keep the ring irregular without `Math.random()`.
const SPARKLES = Array.from({
    length: SPARKLE_COUNT
}, (_, index)=>{
    const angle = index / SPARKLE_COUNT * Math.PI * 2 + index * 7 % 5 * 0.08;
    const distance = 56 + index * 9 % 23;
    return {
        tone: SPARKLE_TONES[index % SPARKLE_TONES.length],
        style: {
            "--dx": `${(Math.cos(angle) * distance).toFixed(1)}px`,
            "--dy": `${(Math.sin(angle) * distance).toFixed(1)}px`,
            animationDelay: `${420 + index * 37 % 120}ms`
        }
    };
});
/** A check mark that draws itself and pops; `md` adds a ripple, `lg` also sparkles. */ export function CelebrationCheck({ size }) {
    const isToastSize = size === "sm";
    return /*#__PURE__*/ _jsxs("span", {
        className: cn("relative inline-flex shrink-0 motion-safe:animate-celebration-pop", SIZE_CLASSES[size]),
        children: [
            !isToastSize && /*#__PURE__*/ _jsx("span", {
                className: "absolute inset-0 rounded-full bg-positive-line motion-safe:animate-celebration-ripple motion-reduce:hidden"
            }),
            size === "lg" && SPARKLES.map(({ tone, style }, index)=>/*#__PURE__*/ _jsx("span", {
                    className: cn("absolute left-1/2 top-1/2 size-2 rounded-full motion-safe:animate-celebration-sparkle motion-reduce:hidden", tone),
                    style: style
                }, index)),
            /*#__PURE__*/ _jsxs("svg", {
                viewBox: "0 0 52 52",
                "aria-hidden": "true",
                className: "relative size-full text-positive-strong",
                children: [
                    /*#__PURE__*/ _jsx("circle", {
                        cx: "26",
                        cy: "26",
                        r: "23",
                        pathLength: 100,
                        strokeDasharray: 100,
                        strokeWidth: isToastSize ? 5 : 3,
                        className: "fill-positive-surface-strong stroke-positive-solid motion-safe:animate-celebration-circle"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15 27.5l7.5 7.5L38 19",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: isToastSize ? 6 : 4.5,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        pathLength: 100,
                        strokeDasharray: 100,
                        className: "motion-safe:animate-celebration-check"
                    })
                ]
            })
        ]
    });
}

//# sourceMappingURL=celebration-check.js.map